import React from "react"

const Kicker = ({ children, className }) => {
  return <div className={`kicker ${className}`}>{children}</div>
}

export default Kicker
